define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def/Action",
	"csi/def/Toolbar",
	"csi/locale",
	"csi/resolver",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/store/_base",
	"csi/store/Names",
	"csi/view/ToolbarPluginSelect",
	"csi/view/Widget"
], function(declare, lang, csi, _, Action, Toolbar, locale, resolver, sessionConstants, {sessionStore}, csiStore, Names, ToolbarPluginSelect, ViewWidget) {

	return declare(ViewWidget, {
		plugins: [],
		_grid: null,

		// String: url to role being configured, or "centric:" for site
		_urlRole: null,

		postMixInProperties: function() {
			// summary: initialize members and globals - use resolver cache so that changes are reflected in cache
			this._urlRole = sessionConstants.roleUrl || csi.EMPTY_URL;
			this.cacheView = resolver.m_cache;

			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: this._getToolbarActions()
			});

			this.inherited(arguments);
		},

		_getPreferencesUrl: function() {
			// summary: return preferences for current role selected - site preferences if no role
			return (sessionStore.getRolePreferences(this._urlRole) || sessionStore.sitePreferences).$URL;
		},

		_getRoleAction: function() {
			// summary: return action to use on toolbar
			return lang.mixin(new Action(), {
				m_id: "ViewConfigSelectRole",
				m_postAction: "_onRole",
				classToolbarPlugin: ToolbarPluginSelect,
				classToolbarPluginParams: {
					showLabel: true,
					store: this._getRoleStore(),
					value: this._urlRole
				}
			});
		},

		_getRoleStore: function() {
			// summary: create store for managed roles
			var data = [csiStore.nameObject(locale.resource("SelectAll"))];

			sessionStore.playableRolesStore.internalQuery().forEach(function(item) {
				data.push(_.clone(item));
			});

			return new Names({
				bSort: false,
				data: data
			});
		},

		_getToolbarActions: function() {
			// summary: return list of toolbar actions
			return [this._getRoleAction(), "refresh"];
		},

		_onRole: function(/*Controller*/ac) {
			// summary: switch between host and supplier portal which will affect list of available types
			this._urlRole = ac.actionValue;
			this._refreshWidget();
		},

		_refreshWidget: function() {
			// summary: reset product if there is supplier request and product field is not fixed
			var plugin = this.getPlugin("ViewConfigSelectRole");
			var store = this._getRoleStore();
			var value = plugin.get("value");

			plugin.set("store", store);

			if (!store.get(value)) {
				plugin.set("value", csi.EMPTY_URL);
			} else {
				this.inherited(arguments);
			}
		}
	});
});
